import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  LIFECYCLE_STAGE_BUILD_COLORS,
  LIFECYCLE_STAGE_BUILD_LABELS,
  type LifecycleStageBuild,
} from '@/constants/lifecycleStages';

interface Props {
  stage: LifecycleStageBuild | null | undefined;
  className?: string;
}

export default function BuildLifecycleStageBadge({ stage, className }: Props) {
  if (!stage) {
    return (
      <span className={cn('text-[10px] text-muted-foreground', className)}>
        Chưa set
      </span>
    );
  }
  return (
    <Badge
      variant="outline"
      className={cn(
        'inline-flex items-center gap-1 text-[10px] px-2 py-0.5 font-semibold rounded-md border',
        LIFECYCLE_STAGE_BUILD_COLORS[stage],
        className,
      )}
    >
      {LIFECYCLE_STAGE_BUILD_LABELS[stage]}
    </Badge>
  );
}
